import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d1ed951"),n=n(),_popScopeId(),n)
const _hoisted_1 = { colspan: "10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "提单信息", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_form_item, {
        label: "提单类型",
        prop: "LadingBillType",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_select, {
            modelValue: _ctx.form.Data.LadingBillType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.LadingBillType) = $event)),
            options: _ctx.EnumLadingBillTypeOption,
            red: _ctx.reds && _ctx.reds.contains('LadingBillType')
          }, null, 8, ["modelValue", "options", "red"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "提单份数",
        prop: "LadingBillNumber",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_select, {
            modelValue: _ctx.form.Data.LadingBillNumber,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.LadingBillNumber) = $event)),
            options: _ctx.EnumLadingBillNumberOption
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "备注",
        prop: "LadingBillRemark",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.LadingBillRemark,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.LadingBillRemark) = $event)),
            type: "textarea",
            rows: 5,
            resize: "none",
            trim: false,
            placeholder: "请填写其他签单要求，如信用证中规定的要求，描述请尽量详细”"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ]))
}